//Done

import React, {useState, useEffect} from 'react';
import { Table, Button, Popconfirm, Modal, Form, InputNumber, Row, Col} from 'antd';
  
export default function SemesterTable () {
    const [modalVisible, setModalVisible] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [dataIsLoading, setDataIsLoading] = useState(false);

    const columns = [
        {
          title: 'Semester',
          dataIndex: 'semester',
          width: '80%',
          defaultSortOrder: 'ascend',
          sorter: (a, b) => a.semester - b.semester,
        },
        {
          title: 'Operation',
          dataIndex: 'operation',
          render: (text, record) =>
            dataSource.length >= 1 ? (
                <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record)}>
                    <Button danger type="text">Delete</Button>
                </Popconfirm>
            ) : null,
        },
    ]; 

    const SemesterModal = ({ visible, onCreate, onCancel }) => {
        const [form] = Form.useForm();
        return (
            <Modal
                visible={modalVisible}
                title="Creating a new semester"
                okText="Create"
                cancelText="Cancel"
                onCancel={onCancel}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreate(values);
                        })
                        .catch((info) => {console.log('Validate Failed:', info);});
                }}
                destroyOnClose={true}
            >
                <Form
                    form={form}
                    layout="vertical"
                    preserve={false}
                >
                    <Form.Item
                        label="Semester"
                        name="semester"
                        rules={[
                            {
                                required: true,
                                type: 'number', 
                                min: 1,
                                max: 10,
                            },
                        ]}  
                    >
                        <InputNumber style={{width: "100%"}}/>
                    </Form.Item>                
                </Form>
            </Modal>
        );
    };

    const handleDelete = (record) => {
        setDataIsLoading(true)
        fetch('https://kh-studentrecordsystem.herokuapp.com/semestersInfo', {
            method: 'DELETE',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(record),
        })
            .then(data => {
                fetch('https://kh-studentrecordsystem.herokuapp.com/semestersInfo')
                    .then(response => response.json())
                    .then(data => {
                        setDataSource(data);
                        setDataIsLoading(false);
                    })
                    .catch((error) => {console.error('Error:', error);});
            })
            .catch((error) => {console.error('Error:', error);});
    };

    useEffect(() => {
        fetch('https://kh-studentrecordsystem.herokuapp.com/semestersInfo')
            .then(response => response.json())
            .then(data => setDataSource(data))
            .catch(err => console.log(err))
    },[])

    const onCreate = (values) => {
        const newData = {
            semester: values.semester,
        }
        const index = dataSource.findIndex(x => x.semester === values.semester);
        if (index !== -1) {
            alert ('This semester has been created');
            setModalVisible(false)
        } else {
            setDataIsLoading(true);
            fetch('https://kh-studentrecordsystem.herokuapp.com/semestersInfo', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(newData),
            })
                .then(data => {
                    fetch('https://kh-studentrecordsystem.herokuapp.com/semestersInfo')
                        .then(response => response.json())
                        .then(data => {
                            setDataSource(data);
                            setModalVisible(false);
                            setDataIsLoading(false);
                        })
                        .catch((error) => {console.error('Error:', error);});
                })
                .catch((error) => {console.error('Error:', error);});
        }
    };

    return (
        <Row justify="center">
            <Col xs={23} lg={{span: 22, offset: 1}} xl={{span: 22, offset: 3}}>
                <div>
                    <Button onClick={() => {setModalVisible(true)}} type="primary" className="pageMainFuncBtn">Add New Semester</Button>

                    <Table
                        rowKey={record => record._id}
                        bordered
                        dataSource={dataSource}
                        columns={columns}
                        pagination={{defaultPageSize: 20}}
                        loading={dataIsLoading}
                    />

                    <SemesterModal
                        visible={modalVisible}
                        onCreate={onCreate}
                        onCancel={() => {setModalVisible(false);}}
                    />
                </div>  
            </Col>
        </Row>        
    );
};